import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HawlModiwlService } from '../awdurdodi/hawl-modiwl.service';

@Injectable({
  providedIn: 'root'
})
export class GuardsHawlModiwlService  {

  constructor(private hawlModiwlService: HawlModiwlService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.hawlModiwlService.gwirioHawl(next.data.modiwl)) {
      return true;
    }

    return false;
  }
}
